export default __webpack_public_path__ + "static/oskar_maksymiuk-9b7859505cd8d0bd8596fadb2b1d3eac.jpg";